import { NavLink } from "react-router-dom";
import { CalendarDays, Users, PieChart, FileText } from "lucide-react";
import { useUser } from "../../context/UserContext";

// Bandeau d'onglets du « Pilotage » établissement (vues sans idclasse).
// Réplique l'habillage de PilotageTabs (classe) mais pointe vers les pages
// coordo. Visible par le coordonnateur ET le délégué ; AUTO-MASQUÉ pour tout
// autre prof et pour le chef (la route eval-nat-niveau est partagée avec lui).
// Aucune prop : tout est lu depuis les contexts, pour une insertion en une
// ligne dans le layout de routes (cf. App.js).
function PilotageCoordoTabs() {
    const { user, etablissementData } = useUser();
    const prof = etablissementData?.professeurs?.find((p) => p.id === user?.id);

    if (user?.role !== "professeur" || !(prof?.coordonateur || prof?.delegue_affectation)) return null;

    const onglets = [
        { label: "Programmation commune", to: "/home/progression", icone: CalendarDays, visible: true },
        { label: "Configuration des groupes", to: "/home/admin-groupe/", icone: Users, visible: true },
        { label: "Répartition par résultats", to: "/home/groupes-common/", icone: PieChart, visible: true },
        // Onglet réservé au délégué (le seul élément du menu restreint par rôle).
        { label: "Résultats nationaux", to: "/home/eval-nat-niveau/", icone: FileText, visible: !!prof?.delegue_affectation },
    ];

    return (
        <div className="px-4 pt-4">
            <div className="inline-flex flex-wrap gap-1 bg-white rounded-xl border border-slate-200 shadow-sm p-1">
                {onglets.filter((o) => o.visible).map(({ label, to, icone: Icone }) => (
                    <NavLink
                        key={to}
                        to={to}
                        className={({ isActive }) =>
                            `flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[13px] font-medium transition-colors duration-200 ${
                                isActive
                                    ? 'bg-gradient-to-br from-blue-500 to-cyan-500 text-white shadow-md shadow-blue-500/30'
                                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                            }`
                        }
                    >
                        <Icone className="w-4 h-4" />
                        {label}
                    </NavLink>
                ))}
            </div>
        </div>
    );
}

export default PilotageCoordoTabs;
